export const requestPasswordResetMutation = /* GraphQL */ `
    mutation requestPasswordResetEmail($email: String!) {
        requestPasswordResetEmail(email: $email)
    }
`
